(function () {
  let jQueryVersion;

  const loadScript = (url, callback) => {
    let script = document.createElement('script');
    script.type = 'text/javascript';

    // If the browser is Internet Explorer.
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null;
          callback();
        }
      };
      // For any other browser.
    } else {
      script.onload = function () {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  function addToCartOk() {
    return Shopify.getCart(function (cart) {
      $('.cart-item-count').text(cart.item_count);
      $('.header-tools-cart').addClass('cart-has-content');
    });
  }

  const initListeners = ($) => {
    $('.split__heading').on('click touch', function () {
      if ($('#' + this.getAttribute('data-id')).css('display') !== 'block') {
        $('.split__detail').slideUp('fast');
        $('.more').html('+').css('font-size', '1.5em').css('line-height', '1');
        $('#' + this.getAttribute('data-id')).slideDown('fast');
        $(this)
          .find('.more')
          .html('&mdash;')
          .css('font-size', '1.155em')
          .css('line-height', '1.3');
      } else {
        $('#' + this.getAttribute('data-id')).slideUp('fast');
        $(this)
          .find('.more')
          .html('+')
          .css('font-size', '1.5em')
          .css('line-height', '1');
      }
    });

    $('#btn_add_to_cart').on('click', function () {
      $('.loader.loader_all').css('visibility', 'visible');
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: window.bia_products }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          addToCartOk();
          setTimeout(function () {
            $('.loader.loader_all').css('visibility', 'hidden');
          }, 1500);
        })
        .catch((err) => {
          console.error(err);
        });
    });

    $('.addSingle').on('click', function (e) {
      e.preventDefault();
      const vid = $(this).data('vid');
      $('.loader.loader_' + vid).css('visibility', 'visible');
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          addToCartOk();
          setTimeout(function () {
            $('.loader.loader_' + vid).css('visibility', 'hidden');
          }, 1500);
        })
        .catch((err) => {
          console.error(err);
        });
    });
  };

  if (typeof jQuery === 'undefined' || parseFloat(jQuery.fn.jquery) < 3.5) {
    loadScript(window.vsjq, function () {
      jQueryVersion = jQuery.noConflict(true);
      initListeners(jQueryVersion);
    });
  } else {
    jQueryVersion = jQuery;
    initListeners(jQueryVersion);
  }
})();
